export default "__VITE_ASSET__330449c0__"